import { Swiper, Navigation, Pagination, Zoom, Lazy } from 'swiper/core';

const initSlider = function() {
  let controlOptions = {};
  if (document.documentElement.clientWidth	>= 768) {
    controlOptions = {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    };
  } else {
    controlOptions = {
      pagination: {
        el: '.swiper-pagination',
      }
    };
  }

  Swiper.use([Navigation, Pagination, Lazy, Zoom]);
  new Swiper('.product_card__image-gallery', {
    preloadImages: false,
    lazy: true,

    on: {
      init: handleImageSwap,
      slideChangeTransitionEnd: handleImageSwap,
    },

    zoom: {
      maxRatio: 2
    },

    ...controlOptions
  });
};

function handleImageSwap() {
    document.querySelectorAll('.swiper-slide-active').forEach((slide) => {
      const highQualityImg = slide.querySelector('.swiper-slide__hq-img');
      const lowQualityImg = slide.querySelector('.swiper-slide__lq-img');

      // Only proceed if high-quality image hasn't been loaded yet
      if (highQualityImg && !highQualityImg.classList.contains('loaded')) {
        const highResImage = new Image();
        highResImage.src = highQualityImg.dataset.src;

      // Load the high-quality image in the background
      highResImage.onload = () => {
        highQualityImg.src = highResImage.src;
        highQualityImg.classList.remove('hidden'); // Show high-quality image
        highQualityImg.classList.add('loaded'); // Mark as loaded for future reference

        // Smoothly transition out the low-quality image
        lowQualityImg.style.opacity = 0;
      };
    }
  });
}

export default initSlider;

